import axios from "axios";

import { toastify } from "../components/common/notification";

import { url } from ".";

import { LogParam } from "../types/logParam";
import { errorMessage } from "../utils/common";
import { logError, logInfo } from "../utils/logger";

// always set function name and message for every executable block
// data is optional
const logParams : LogParam = {
  applicationName : "Orchestrator Client",
  screenModuleName: "client\\src\\controllers\\form.ts",
  functionName: "",
  message: "",
}

export const createFormApi = (token: string, data: unknown) =>
  axios
    .post(`${url}/form`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      logParams.functionName = "createFormApi";
      logParams.message = "created form";
      logInfo(logParams);
    
      return res.data; 
    })
    .catch((error) =>
    {
      logParams.functionName = "createFormApi";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message?.length > 0
          ? error.response.data.message
          : "Something went wrong"
      )}
    );

export const getFormApi = (formId: string) =>
  axios
    .get(`${url}/form/metadata/${formId}`)
    .then((res) => {
      logParams.functionName = "getFormApi";
      logParams.message = `retrieved form ${formId}`;
      logInfo(logParams);

      return res.data; 
    })
    .catch((error) =>
    {
      logParams.functionName = "getFormApi";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message?.length > 0
          ? error.response.data.message
          : "Something went wrong"
      )}
    );

export const getOrgFormsApi = (orgId: string, token: string) =>
  axios
    .get(`${url}/form/organization/${orgId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => { 
      logParams.functionName = "getOrgFormsApi";
      logParams.message = `retrieved forms for org ${orgId}`;
      logInfo(logParams);

      return res.data; 
    })
    .catch((error) =>
    {
      logParams.functionName = "getOrgFormsApi";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message?.length > 0
          ? error.response.data.message
          : "Something went wrong"
      )}
    );

export const updateFormApi = (token: string, formId: string, data: unknown) =>
  axios
    .put(`${url}/form/${formId}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      logParams.functionName = "updateFormApi";
      logParams.message = `updated form ${formId}`;
      logInfo(logParams);  

      return res.data; 
    })
    .catch((error) =>
    {
      logParams.functionName = "updateFormApi";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message?.length > 0
          ? error.response.data.message
          : "Something went wrong"
      )}
    );

export const deleteFormApi = (token: string, formId: string) =>
  axios
    .delete(`${url}/form/${formId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => { 
      logParams.functionName = "deleteFormApi";
      logParams.message = `deleted form ${formId}`;
      logInfo(logParams);

      return res.data; 
    })
    .catch((error) =>
    {
      logParams.functionName = "deleteFormApi";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message?.length > 0
          ? error.response.data.message
          : "Something went wrong"
      )}
    );

export const submitFormApi = (queueName: string, data: unknown) =>
  axios
    .put(`${url}/queue/form/${queueName}`, data)
    .then((res) => { 
      logParams.functionName = "submitFormApi";
      logParams.message = `submitted form to queue ${queueName}`;
      logInfo(logParams);
    
      return res.data; 
    })
    .catch((error) =>
    {
      logParams.functionName = "submitFormApi";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message?.length > 0
          ? error.response.data.message
          : "Something went wrong"
      )}
    );

export const getEditFormAPI = (formId: string, token: string) =>
  axios
    .get(`${url}/form/${formId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => { 
      logParams.functionName = "getEditFormApi";
      logParams.message = `retrieved form ${formId}`;
      logInfo(logParams);

      return res.data; 
    })
    .catch((error) =>
    {
      logParams.functionName = "getEditFormApi";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message?.length > 0
          ? error.response.data.message
          : "Something went wrong"
      )}
    );
